class CatalogNavbarController {
  constructor (I18n) {
    'ngInject'
    this.I18n = I18n
    this.types = [{
      id: 'appsAndServices',
      label: 'catalog.type.appsAndServices'
    }, {
      id: 'maps',
      label: 'catalog.type.maps'
    }]
  }
}

export default CatalogNavbarController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/catalog-navbar/catalog-navbar.controller.js